export const brisbaneTerrainCrs: string = "EPSG:7856+5711";
